import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import styledComponent from '../../utils/styledComponent';

/*     STYLED COMPONENT     */

const StyledDiv = styledComponent('div', {
  '&.filterRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  '&.footerWrapper': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

/*     RECEIPTMODAL COMPONENT     */

const ReceiptModal = (props) => {
  return (
    <StyledDiv>
      {Object.keys(props.deploymentResponse).length > 0 && (
        <Modal
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            {props.deploymentResponse.deployment === 'success' && (
              <div>
                <h3>
                  The FridgeSoftwareVersion table was successfully updated.
                </h3>
                {props.deploymentResponse.pilot !== 'N/A' && (
                  <div>
                    {props.deploymentResponse.pilot === 'success' && (
                      <h3>
                        The FridgeSoftwarePilots table was successfully updated.
                      </h3>
                    )}
                    {props.deploymentResponse.pilot !== 'success' && (
                      <div>
                        <h3>
                          The FridgeSoftwarePilots table failed to update.
                        </h3>
                        <h4>
                          Error Message:
                          {props.deploymentResponse.pilot}
                        </h4>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {props.deploymentResponse.deployment !== 'success' &&
              props.deploymentResponse.deployment !== 'N/A' && (
                <div>
                  {props.deploymentResponse.deployment ===
                    'The following fridges failed to update: ' && (
                    <div>
                      <h3>The FridgeSoftwareVersion table failed to update.</h3>
                      <h4>The following fridges failed to update:</h4>
                      <br />
                      {props.failedFridges.map((id) => {
                        return (
                          <span>
                            {id}
                            <br />
                          </span>
                        );
                      })}
                    </div>
                  )}
                  {props.deploymentResponse.deployment !==
                    'The following fridges failed to update: ' && (
                    <div>
                      <h3>The FridgeSoftwareVersion table failed to update.</h3>
                      <h4>
                        Error Message: {props.deploymentResponse.deployment}
                      </h4>
                    </div>
                  )}
                </div>
              )}
            {props.deploymentResponse.deployment === 'N/A' && (
              <div>
                {props.deploymentResponse.pilot === 'success' && (
                  <h3>
                    The FridgeSoftwarePilots table was successfully updated.
                  </h3>
                )}
                {props.deploymentResponse.pilot !== 'success' && (
                  <div>
                    <h3>The FridgeSoftwarePilots table failed to update.</h3>
                    <h4>
                      Error Message:
                      {props.deploymentResponse.pilot}
                    </h4>
                  </div>
                )}
              </div>
            )}
            <div
              className="footerWrapper"
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <div className="buttonWrapper">
                <Button
                  onClick={() => {
                    props.onHide();
                  }}
                  style={{
                    height: '40px',
                    borderWidth: '2px',
                    color: '#368007',
                    backgroundColor: '#FFFFFF',
                    borderColor: '#368007',
                    outline: 'none',
                  }}
                >
                  CLOSE
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </StyledDiv>
  );
};

export default ReceiptModal;
